import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import AgentGroupItem from "./AgentGroupItem";
import Modal from "../../../../../Components/UI/Modal/Modal";
import CloseButton from "../../../../../Components/UI/CloseButton/CloseButton";
import Field from "../../../../Settings/Content/Components/Field";

import {
  RequestAgentGroups,
  RequestCreateAgentPolicy,
} from "../../../../../store/actions/integrationsActions";
import { addNotification } from "../../../../../store/actions/notifierActions";

import "./styles.scss";

const DEFAULT_FORM_DATA = {
  name: "",
  description: "",
  groups: [],
};

const CreateAgentPolicy = ({ showPopup, setShowPopup, selectedHost }) => {
  const dispatch = useDispatch();

  const agentGroups = useSelector((state) => state.integrations.agentGroups);

  const [formInputs, setFormInputs] = useState(DEFAULT_FORM_DATA);

  useEffect(() => {
    dispatch(RequestAgentGroups(selectedHost));
  }, [dispatch, selectedHost]);

  const handleInputChange = (e) => {
    const name = e.target.name;
    let value = e.target.value;

    if (name === "agentGroupItem") {
      value = Number(value);
      setFormInputs((prevSettings) => ({
        ...prevSettings,
        groups: prevSettings.groups.includes(value)
          ? prevSettings.groups.filter((g) => g !== value)
          : [...prevSettings.groups, value],
      }));
    } else {
      setFormInputs((prevSettings) => ({
        ...prevSettings,
        [name]: value,
      }));
    }
  };

  const createPolicyHandler = () => {
    if (!formInputs.name) {
      dispatch(
        addNotification({ message: "Name field is required", options: { variant: "error" } }),
      );
      return;
    }
    dispatch(
      RequestCreateAgentPolicy({
        ...formInputs,
        host: selectedHost,
        onSuccess: () => {
          setShowPopup(false);
          setFormInputs(DEFAULT_FORM_DATA);
        },
      }),
    );
  };

  return showPopup ? (
    <Modal active={showPopup} setActive={setShowPopup} type="create-agent-policy">
      <h2>Create Agent Policy</h2>
      <div className="create-agent-policy__close-btn">
        <CloseButton onClick={() => setShowPopup(false)} />
      </div>

      <div className="create-agent-policy__form">
        <Field
          label="Policy Name"
          width="100%"
          value={formInputs.name}
          onChange={(e) => handleInputChange({ target: { name: "name", value: e.target.value } })}
          placeholder="e.g. Win10 Agent Rules"
          name="name"
        />

        <Field
          label="Description (optional)"
          width="100%"
          value={formInputs.description}
          onChange={(e) =>
            handleInputChange({ target: { name: "description", value: e.target.value } })
          }
          placeholder="e.g. Strict rules for win10 agents"
          name="description"
        />

        <p className="settings__label">Assign Agent Groups</p>
        <div>
          {agentGroups.map((agentGroup) => (
            <AgentGroupItem
              key={agentGroup.id}
              agentGroup={agentGroup}
              onCheck={handleInputChange}
              checked={formInputs.groups.includes(agentGroup.id)}
            />
          ))}
        </div>
      </div>

      <div className="create-agent-policy__actions">
        <button className="danger-button" onClick={() => setShowPopup(false)}>
          Cancel
        </button>
        <button className="primary-button" onClick={createPolicyHandler}>
          Create Policy
        </button>
      </div>
    </Modal>
  ) : null;
};

export default CreateAgentPolicy;
